/* eslint-disable */
export default function (reducers, initial) {
	return function (state = initial || {}, action) {
		return reducers.reduce((stepState, stepReducer) => {
			return stepReducer(stepState, action);
		}, state);
	};
}
